import React from 'react';

var AVATAR_COLORS = ['#18BBF7', '#0D67C7', '#052E5C', '#747679', '#FDA308', '#98C332', '#159F45', '#B800B2', '#F22C44'];

var getInitials = function getInitials(name) {
    var firstInitial = name.slice(0, 1);
    var lastInitial = name.slice(name.lastIndexOf(' ') + 1, name.lastIndexOf(' ') + 2);
    return firstInitial + lastInitial;
};

var AvatarInitials = function AvatarInitials(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        id = _ref.id,
        name = _ref.name;

    var avatarColorSelector = parseInt(id, 10) || 0;
    var backgroundColor = AVATAR_COLORS[avatarColorSelector % AVATAR_COLORS.length];
    return React.createElement(
        'span',
        {
            className: 'avatar-initials ' + className,
            style: { backgroundColor: backgroundColor }
        },
        getInitials(name)
    );
};

AvatarInitials.propTypes = {
    className: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired
};
export default AvatarInitials;
import PropTypes from 'prop-types';